import { ComingSoon } from '../components/ComingSoon';

export function XApiUsagePage() {
  return (
    <ComingSoon
      title="X API Usage"
      phase="Phase 3"
      summary="Direct visibility into the spend driver. Replaces what would be the IPFS admin's MCP tab — X Bot has no MCP server, but it does have a per-call X API spend that needs operator attention."
      bullets={[
        'Total calls MTD, spend MTD, calls/day average, top endpoint',
        'Time series: calls/day and spend/day (range toggle 7d/30d/90d/1y/All)',
        'Endpoint breakdown: /tweets/search/all (report fetcher), /users/by/username (relay bootstrap), /users/:id/tweets (relay polling), /tweets/:id (single-tweet)',
        'Top spenders table: chats with highest X API spend MTD, linked to ChatDetail',
        'New CloudWatch custom metric XBot/XApi/Calls dimensioned by CallType — small instrumentation in XTwitterFetcher methods'
      ]}
    />
  );
}
